<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

const props = defineProps({
  accountId: { type: [String, Number], required: true },
  imovelId: { type: [String, Number], default: '' },
  financedValue: { type: [String, Number], default: 0 },
  hasSfh: { type: Boolean, default: false },
  firstPurchase: { type: Boolean, default: false },
  isLoggedIn: { type: Boolean, default: true },
});

const emit = defineEmits(['click']);

const mortgageHref = computed(() => {
  const params = new URLSearchParams();
  if (props.imovelId) params.set('imovel_id', props.imovelId);
  if (props.financedValue) params.set('financed_value', props.financedValue);
  params.set('has_sfh', String(props.hasSfh));
  params.set('first_purchase', String(props.firstPurchase));

  return frontendURL(
    `accounts/${props.accountId}/financeiro?${params.toString()}`
  );
});

const handleClick = () => {
  emit('click', {
    houseId: props.imovelId,
    financedValue: Number(props.financedValue || 0),
    hasSfh: props.hasSfh,
    firstPurchase: props.firstPurchase,
    isLoggedIn: props.isLoggedIn,
  });
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <a
    :href="mortgageHref"
    class="inline-flex min-h-10 items-center justify-center gap-2 rounded-lais border border-lais-border bg-white px-3 text-[13px] font-semibold text-lais-primary transition-colors hover:border-lais-primary hover:bg-lais-primary-50"
    @click="handleClick"
  >
    <span class="i-lucide-landmark size-4" aria-hidden="true" />
    Abrir fluxo de financiamento
  </a>
</template>
